import { FunctionComponent } from "react";
import styles from "./cardGrid.module.css";

export const CardGrid: FunctionComponent = ({ children }) => {
  return <div className={styles.cardGrid}>{children}</div>;
};
